(function () {
  document.querySelectorAll('.tm-hero').forEach(function (hero) {
    var slides = hero.querySelectorAll('.tm-hero-slide');
    var dots = hero.querySelectorAll('.tm-hero-dots button');
    if (slides.length < 2) return;
    var i = 0, timer;
    var delayMs = (parseFloat(hero.dataset.slideDelay) || 6) * 1000;

    // Slide 1+ start as display:none, so the shared IntersectionObserver
    // (scroll-reveal-tatemada.js) never sees their [data-reveal] copy.
    // Reveal a slide's own copy here instead, the first time it activates;
    // re-adding the class on later activations is a harmless no-op.
    function revealSlide(slide) {
      slide.querySelectorAll('[data-reveal]').forEach(function (el) {
        el.classList.add('is-revealed');
      });
    }

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
      revealSlide(slides[i]);
    }

    function next() { show(i + 1); }

    function restart() {
      clearInterval(timer);
      timer = setInterval(next, delayMs);
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        show(parseInt(d.dataset.slide, 10));
        restart();
      });
    });

    show(0);
    restart();
  });
})();
